import { jumpScrollTo } from './smoothScroll';

const HOLD_MS = 1000;
const INPUTS = ['wheel', 'pointerdown', 'touchstart', 'keydown'];

let releaseHold = null;

const holdScroll = top => {
  let frame = 0;
  let started = 0;

  const release = () => {
    cancelAnimationFrame(frame);
    INPUTS.forEach(type => window.removeEventListener(type, release, true));
    if (releaseHold === release) releaseHold = null;
  };

  const tick = now => {
    if (!started) started = now;
    if (now - started > HOLD_MS) return release();
    if (Math.abs(window.scrollY - top) > 1) jumpScrollTo(top);
    frame = requestAnimationFrame(tick);
  };

  INPUTS.forEach(type => window.addEventListener(type, release, { capture: true, passive: true }));
  frame = requestAnimationFrame(tick);
  releaseHold = release;
};

const leftAt = new Map();
let lastHref = null;
let lastY = 0;

const noteScroll = () => {
  const href = window.location.href;
  if (href !== lastHref) {
    if (lastHref !== null) leftAt.set(lastHref, lastY);
    lastHref = href;
  }
  lastY = window.scrollY;
};

export const trackRouteScroll = () => {
  if (typeof window === 'undefined' || lastHref !== null) return;
  noteScroll();
  window.addEventListener('scroll', noteScroll, { passive: true });
  window.addEventListener('popstate', noteScroll);
};


export const restoreRouteScroll = ({ prevRouterProps, routerProps: { location }, getSavedScrollPosition }) => {
  if (releaseHold) releaseHold();

  const prev = prevRouterProps && prevRouterProps.location;
  const samePage = prev && prev.pathname === location.pathname;

  if (samePage && prev.hash === location.hash) return false;

  if (lastHref !== null) noteScroll();
  const unkeyed = !(location.state && location.state.key);

  let top;
  if (samePage || (unkeyed && location.hash)) top = leftAt.get(location.href);
  if (top === undefined && prev && !samePage) top = getSavedScrollPosition(location)[1] || 0;

  if (top === undefined) {
    jumpScrollTo(window.scrollY, window.scrollX);
    return false;
  }

  jumpScrollTo(top);
  if (top > 0) holdScroll(top);

  return false;
};
